export class RunningUploadsInfo {
  public countRunningUploads: number = 0;
  public countUploadErrors: number = 0;
}
